module.exports = __webpack_public_path__ + "static/media/product-6.6d623e7f.png";